<template>
  <Line
    :options="{
      scales: {
        x: {
          ticks: {
            display: false
          }
        },
        y: {
          ticks: {
            display: true
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        tooltip: false
      }
    }"
    :data="{
      labels: bids.map((bid) => bid.bidTime),
      datasets: [
        {
          data: bids.map((bid) => bid.priceAfterBid),
          pointBackgroundColor: bids.map((bid) => myLot && myLot.myBids.includes(bid.uuid) ? '#008800' : '#000088')
        }
      ]
    }"
  />
</template>

<script setup>
import { Line } from 'vue-chartjs'

const props = defineProps({
    bids: {
        type: Array,
        required: true
    },
    lot: {
        type: Object,
        required: true
    },
    myLot: {
        type: Object,
        required: false,
        default: null
    }
})
</script>
